import { questionDefaults } from './questionDefaults';
import { cleanWardNames } from './validate';
import { sortEventDates } from './dates';
import { sortWardNames } from './wards';
import { formatPhone } from './phone';
import type { EventInput } from './types';

/** An event's configuration as it is saved and published: trimmed, dates and wards in order, phone formatted. */
export function normaliseEventInput(input: EventInput): EventInput {
  const t = (s: unknown) => (typeof s === 'string' ? s.trim() : '');
  return {
    level: input.level,
    stakeName: t(input.stakeName),
    wardName: input.level === 'ward' ? t(input.wardName) : null,
    wardNames: input.level === 'stake' && Array.isArray(input.wardNames) ? sortWardNames(cleanWardNames(input.wardNames)) : [],
    wardEntry: input.level === 'stake' ? t(input.wardEntry) : '',
    name: t(input.name),
    dates: sortEventDates((input.dates ?? []).map((d) => ({ start: d.start, ...(d.end && d.end !== d.start ? { end: d.end } : {}) }))),
    description: t(input.description),
    leaderName: t(input.leaderName),
    leaderPhone: formatPhone(t(input.leaderPhone)),
    leaderEmail: t(input.leaderEmail).toLowerCase(),
    ...(input.adultAge && input.adultAge !== 18 ? { adultAge: input.adultAge } : {}),
    fields: Array.isArray(input.fields) ? input.fields.map(questionDefaults) : input.fields ?? [],
    pdfFormsSchemaVersion: 2,documentForms:structuredClone(input.documentForms??[]),
  };
}
